import React from "react";
import {
  FormatBold,
  FormatClear,
  FormatItalic,
  FormatQuoteOutlined,
  FormatUnderlined,
} from "@mui/icons-material";
import { createUseStyles } from "react-jss";
import { Divider, IconButton } from "@mui/material";
import { getHasInlineStyleByKey, toggleInlineStyle } from "./helpers";

const useStyles = createUseStyles(({ colors }) => ({
  inlineOptions: {
    order: 5,
    display: "flex",
  },
  iconButton: {
    "&.active": {
      backgroundColor: `${colors.black}33`,
    },
  },
}));

export const InlineOptions = ({ onChange, editorState }) => {
  const classes = useStyles();

  const options = [
    {
      type: "BOLD",
      Icon: FormatBold,
    },
    {
      type: "ITALIC",
      Icon: FormatItalic,
    },
    {
      type: "UNDERLINE",
      Icon: FormatUnderlined,
    },
  ];

  return (
    <div className={classes.inlineOptions}>
      {options.map(({ type, Icon }) => (
        <IconButton
          key={type}
          className={`${classes.iconButton} ${
            getHasInlineStyleByKey(editorState, type) ? "active" : ""
          }`}
          onClick={(e) => {
            e.preventDefault();
            onChange(toggleInlineStyle(editorState, type));
          }}
        >
          <Icon sx={{ color: "#00000099" }} size="small" />
        </IconButton>
      ))}
      <Divider orientation="vertical" variant="middle" flexItem />
    </div>
  );
};

export const PullQuoteToolbarButton = ({
  onToggle,
  isPullQuote,
  title,
  editorState,
  onChange,
  modalHandler,
  config,
  translations,
  ...rest
}) => (
  <div
    className="rdw-option-wrapper"
    title={title}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onToggle?.();
    }}
    onMouseDown={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
    style={{
      backgroundColor: isPullQuote ? "#FFB800" : undefined,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
    data-testid="toolbar-pull-quote-button"
  >
    <FormatQuoteOutlined
      sx={{
        fontSize: "18px",
        color: isPullQuote ? "#0C0B0F" : "#00000099",
      }}
    />
  </div>
);

export const ClearFormattingToolbarButton = ({
  onClear,
  title,
  editorState,
  onChange,
  modalHandler,
  config,
  translations,
  ...rest
}) => (
  <div
    className="rdw-option-wrapper"
    title={title}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onClear?.();
    }}
    onMouseDown={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
    style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    data-testid="toolbar-clear-formatting-button"
  >
    <FormatClear sx={{ fontSize: "18px", color: "#00000099" }} />
  </div>
);
